import { ColumnDef } from "@tanstack/react-table";
import { OrganizationItem } from "@/endpoints/dryp/backoffice";
import { ActionsMenuColumn } from "@/components/tableColumns/ActionsMenuColumn";
import { DateTimeColumn } from "@/components/tableColumns/DateTimeColumn/DateTimeColumn";
import { BuildingIcon } from "lucide-react";
import { useMemo } from "react";
import { useStore } from "@/hooks/useStore";

export function useOrganizationColumns(refresh: () => void): ColumnDef<OrganizationItem>[] {
	const {
		uiStore: { modalStore },
	} = useStore();

	return useMemo(
		() => [
			{
				accessorKey: "id",
				header: "ID",
			},
			{
				accessorKey: "name",
				header: "Name",
				cell: ({ row }) => {
					const { name } = row.original;
					return (
						<div className="flex gap-2">
							<BuildingIcon className="h-4 w-4 text-blue-400" />
							{name}
						</div>
					);
				},
			},
			{
				accessorKey: "description",
				header: "Description",
			},
			{
				accessorKey: "userCount",
				header: "Users",
			},
			DateTimeColumn<OrganizationItem>({
				accessorKey: "createdAt",
				header: "Created",
			}),
			DateTimeColumn<OrganizationItem>({
				accessorKey: "updatedAt",
				header: "Updated",
			}),
			ActionsMenuColumn<OrganizationItem>({
				actions: [
					{
						label: "Edit",
						onSelect: row => {
							modalStore.open("addOrganization", {
								organization: row.original,
								onSuccess: refresh,
							});
						},
					},
				],
				header: "",
				className: "w-10",
			}),
		],
		[],
	);
}
